//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '../plugins/axios';

import Btn from '../components/Btn.vue';
import IconAngle from '../components/IconAngle.vue';

export default {
	name: 'FooterSubscribe',

	components: { Btn: Btn, IconAngle: IconAngle },

	data: function data() {
		return {
			mail: '',
			message: null
		};
	},


	computed: {
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		action: function action() {
			return this.$store.state.settings.subscribeAction;
		},
		title: function title() {
			return this.$lang('newsSubscribe', null, this.lang);
		}
	},

	methods: {
		clearForm: function clearForm() {
			this.mail = '';
			this.message = null;
		},
		closeMessage: function closeMessage() {
			this.message = null;
		},
		sendForm: function sendForm() {
			var _this = this;

			var data = new FormData();

			data.append('mail', this.mail);

			axios.post(this.action, data).then(function (res) {
				_this.clearForm();
				_this.message = res.data.message;
			}).catch(function (error) {
				_this.message = res.data.message;
			});
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FooterSubscribe.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FooterSubscribe.vue
// module chunks = 5